import types from './types';

const defaultState = {
  appName: 'CERES',
  viewChangeCounter: 0,
  sidebar: false,
  isLoading: false,
  errorData: null
};

export default (state = defaultState, { type, data, ...action }) => {
  switch (type) {
    case types.TOGGLE_SIDEBAR:
      return {
        ...state,
        sidebar: !state.sidebar
      };

    case types.TOGGLE_ERROR_PAGE:
      let errorData = action && action.params ? action.params.errorData : null;
      return { ...state, errorData };

    case types.GET_NOTIFICATION:
      return { ...state, isLoading: true };
    case types.GET_NOTIFICATION_SUCCESS:
      return { ...state, notification: data, isLoading: false };
    case types.GET_NOTIFICATION_FAILURE:
      return { ...state, isLoading: false };

    default:
      return state;
  }
};
